module.exports = __webpack_public_path__ + "static/img/14.6f2e8a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/eng/14.png
// module id = 6C/S
// module chunks = 0